const thing = {
  "entities": {
    "home": {
      "title": 'Performance | Theory',
      "image": '',
      "overview": 'Welcome! This interactive concept rhizome features short introductory modules on select theories, movements, relevant figures, and definitions of key terms. This evolving platform is intended as a point of departure for research, and is by no means exhaustive.'
    },
    "QueerTheory": {
      "title": "Queer Theory",
      "overview": 'Queer theory is a field of critical discourse that critiques those cultural institutions and practices which enforce normative ways of being, doing, and knowing. It builds upon feminist re-conceptualizations of gender and sexuality by adding the perspective of thinkers who challenge the very viability of, for example, gender identification or sexual orientation. Aligned with the poststructuralist critique of the humanist model of the subject, queer theory offers various understandings of human identity as created performatively, constructed discursively, or else always culturally and historically specific—i.e., never age-old, intrinsic, or by nature.\n\nWhile often associated with the LGBT community, queer theory asks questions beyond any one cultural group, and does not limit itself to conversations regarding sexuality and gender. In fact, queer theory joins other theoretical projects in understanding that racial, sexual, national, class, and gender identities all exist at a complex intersection with one another in any given person or culture. As such, queer theory is as much a mode of inquiry and analysis as it is a study of people who call themselves “queer.” In general, queer theory itself queers—in an intellectual and theory sense—by taking up various projects of de-legitimizing, troubling, challenging, camping up, or de-familiarizing. It finds objects of analysis across history, but most always seeks to de-stabilize the patriarchal, heteronormative, and racist underpinnings of our society.',
      "image": null,
      "contributor": "Nevarez Encinias",
      "type": "Module",
      "url": null
    },
    "Disidentifications": {
      "title": "Disidentifications",
      "overview": "",
      "image": "http://pictures.abebooks.com/isbn/9780816630158-us-300.jpg",
      "type": "Work",
      "url": null
    },
    "CruisingUtopia": {
      "title": "Cruising Utopia",
      "overview": "",
      "image": "http://nyuconnexus.seisan.com/uploads/products/9780814757284/9780814757284_Detail.jpg",
      "type": "Work",
      "url": null
    },
    "TheTroubleWithNormal": {
      "title": "The Trouble With Normal",
      "overview": "",
      "image": "https://images-na.ssl-images-amazon.com/images/I/41PM3FYGXWL._SX314_BO1,204,203,200_.jpg",
      "type": "Work",
      "url": null
    },
    "NoFuture": {
      "title": "No Future",
      "overview": "",
      "image": "https://www.dukeupress.edu/Assets/Books/978-0-8223-3369-2_pr.jpg",
      "type": "Work",
      "url": null
    },
    "ThisBridgeCalledMyBack": {
      "title": "This Bridge Called My Back",
      "overview": "",
      "image": "https://images-na.ssl-images-amazon.com/images/I/51X6018Z6ML._SX299_BO1,204,203,200_.jpg",
      "type": "Work",
      "url": null
    },
    "GenderTrouble": {
      "title": "Gender Trouble",
      "overview": "",
      "image": "https://images-na.ssl-images-amazon.com/images/I/51XxjlfX-yL._SY344_BO1,204,203,200_.jpg",
      "type": "Work",
      "url": null
    },
    "FearofaQueerPlanetQueerPoliticsandSocialTheory": {
      "title": "Fear of a Queer Planet: Queer Politics and Social Theory",
      "overview": "",
      "image": "https://images-na.ssl-images-amazon.com/images/I/51Q1JMERK5L._SY344_BO1,204,203,200_.jpg",
      "type": "Work",
      "url": null
    },
    "GloriaAnzaldua": {
      "title": "Gloria Anzaldúa",
      "overview": "Gloria Anzaldúa was born in 1942 and died in 2004. She was a scholar of Chicana cultural theory, feminism, and queer theory. She is well known for editing _This Bridge Called My Back: Writings by Radical Women of Color_ with Cherríe Moraga and for writing the highly influential _Borderlands/La Frontera: The New Mestiza_. She often wrote many of her texts in “Spanglish.” In her essay “La Prieta,” collected in _This Bridge Called My Back_, she argues that the queer can also be considered in terms of race, giving a personal account of the ways in which her skin color affected her life as a queer woman. Anzaldúa writes, “in [my mother’s] eyes and in the eyes of others I saw myself reflected as ‘Strange’, ‘abnormal’, ‘QUEER.’ I saw no other reflection.” In her writing, she also argues that even within the groups with which one self-identifies, one can feel isolated, due to other differences. On this topic, Anzaldúa says “we are the queer groups, the people that don’t belong anywhere, not in the dominant world nor completely within our own respective cultures.”",
      "image": "https://i.pinimg.com/originals/a0/ce/27/a0ce272717e85dd6e8ffcb0c52e82a5e.jpg", // https://upload.wikimedia.org/wikipedia/commons/1/11/Gloria_Anzaldua.jpg",
      "type": "Author",
      "url": null
    },
    "JoseEstebanMunoz": {
      "title": "José Esteban Muñoz",
      "overview": "José Esteban Muñoz was born in 1967 and died in 2013. He was a scholar of performance studies, queer theory, and visual culture, and served as the Chair of the Department of Performance Studies at New York University. Muñoz’s two main works, _Disidentifications: Queers of Color and the Performance of Politics_ and _Cruising Utopia: The Then and There of Queer Futurity_, critique contemporary gay politics and culture, while also offering theories that have deeply influenced the field of queer studies and contributed to contemporary conceptions of queerness, at large.",
      "image": "https://bullybloggers.files.wordpress.com/2013/12/4_13.jpg",
      "type": "Author",
      "url": null
    },
    "JudithButler": {
      "title": "Judith Butler",
      "overview": "",
      "image": "http://whc.yale.edu/sites/default/files/images/JudithButler2015.jpg",
      "type": "Author",
      "url": null
    },
    "LeeEdelman": {
      "title": "Lee Edelman",
      "overview": "Lee Edelman was born in 1953. He began his career as a scholar of American poetry. Later he was influenced and became a central figure in the movement of queer theory and in disseminating, dissecting, and enlightening new ideas into the field. Currently he holds a teaching position at Tufts University as the Fletcher Professor of English Literature. He is married to a fellow professor in the department, Joseph Litvak. He is most known for his work, _No Future: Queer Theory and the Death Drive_.",
      "image": "http://wmst.umd.edu/queer/wp-content/uploads/bfi_thumb/Photo-10-28-15-11-52-35-PM-mh9uzeiwd4voy7y5h43bhrhjnhsb6gauta3iy2j47o.jpg",
      "type": "Author",
      "url": null
    },
    "MichaelWarner": {
      "title": "Michael Warner",
      "overview": "Michael Warner was born in 1958. He is the Seymour H. Knox Professor of English Literature and American Studies at Yale Univeristy. His publications include The _Trouble with Normal_, _American Sermons_, and _Publics and Counterpublics_. His work ranges from scholarship on American literature, to theoretical writings, and journalism. Much of his writing relates to queer theory. In his book _The Trouble with Normal_, Warner discusses the role of morality in sex and politics. He argues that sex is not only a display of love or affection in America, but is also seen as immoral. Warner argues that the American conception of what is and isn’t moral affects law and politics, which in turn affects those that are considered different and strange, such as the American homosexual. Warner offers the Defense of Marriage Act as an example and also argues that the American government bases their programs on principles of morality. Furthermore, he offers that “…when it comes to moralistic programs, the government has no shortage of cash.”",
      "image": "http://d.gr-assets.com/authors/1390417571p5/76779.jpg",
      "type": "Author",
      "url": null
    },
    "queer": {
      "title": "queer",
      "overview": "A contested term generally denoting a sexual or gender identity, or (sexual) lifestyle, that does not conform to established ideas of sexuality, gender, or conventional heteronormative behavior.\n\nWhile the etymology of the word is uncertain, it is thought to perhaps originate from the German quer meaning traverse, oblique, crosswise, directed sideways, at odds with others. Starting in the late 19th century, the term was used pejoratively to designate persons in same-sex relationships. However, in the 1980s the word was reclaimed by scholars and activists. The term was used self-referentially and served to establish community.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "heteronormative": {
      "title": "heteronormative",
      "overview": "The term heteronormative designates a view that regards gender roles as fixed to biological sex and heterosexuality as the normal, default, or preferred sexual orientation.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "antinormative": {
      "title": "antinormative",
      "overview": "Opposing or countering that which is normative or standard. Queer theorizing is often thought to be shaped by an antinormative sensibility.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "sexuality": {
      "title": "sexuality",
      "overview": "The quality of being sexual. The possession or expression of sexual nature, instinct, or feelings.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "gender": {
      "title": "gender",
      "overview": "Gender commonly refers to a range of characteristics pertaining to masculinity and femininity. In 1955, sexologist John Money distinguished between biological sex and gender as a role. This distinction was later embraced by feminist and queer theory, which view gender as a social construct.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "genderidentity": {
      "title": "gender identity",
      "overview": "Gender identity refers to one’s own experience of one’s gender.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "disidentification": {
      "title": "disidentification",
      "overview": "A concept originally developed by José Muñoz in his 1999 book _Disidentifications: Queers of Color and the Performance of Politics_. The term refers to the survival strategies that the minoritarian subject practices in order to negotiate a phobic majoritarian public sphere. \n\n> “Disidentification is about recycling and rethinking encoded meaning. The process of disidentification scrambles and reconstructs the encoded message of a cultural text in a fashion that both exposes the encoded message’s universalizing and exclusionary machinations and recircuits its workings to account for, include, and empower minority identities and identifications. Thus, disidentification is a step further than cracking open the code of the majority; it proceeds to use this code as raw material for representing a disempowered politics or positionality that has been rendered unthinkable by the dominant culture” (1999:31).",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "JudithButlerBritannica": {
      "title": "Judith Butler (Britannica)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "https://www.britannica.com/biography/Judith-Butler"
    },
    "TheoryorgonButler": {
      "title": "Theory.org on Butler",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://www.theory.org.uk/ctr-butl.htm"
    },
    "PoemsbyAnzaldua": {
      "title": "Poems by Anzaldúa",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "https://www.poetryfoundation.org/poems-and-poets/poets/detail/gloria-e-anzaldua"
    },
    "InterviewwithMunozWhatisPerformanceStudies": {
      "title": "Interview with Muñoz: What is Performance Studies?",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://hidvl.nyu.edu/video/003305734.html"
    },
    "Structuralism": {
      "title": "Structuralism",
      "overview": "Structuralism is an intellectual movement that first emerged in France in the 1920s and reached its height in the 1960s. This school of thought was greatly influenced by the structural linguistics of Ferdinand de Saussure and Roman Jacobson. As a methodology, structuralism seeks to uncover the underlying patterns and structures of cultural practices. Structuralist thought further asserts that all aspects of human activity can best be understood in terms of their relationship to larger, overarching systems or structures. When applied to sociology and cultural anthropology, most notably by Claude Lévi-Strauss, structuralism sought to analyze the structure or form of human society and social relationships and was most concerned with the networks of communication and thought undergirding all of human social and cultural behavior.\n\nWhile structuralism has been widely criticized for—among others—its ahistoricity, determinism, and positivism, it is recognized as an important school of thought that was extremely influential on fields such as anthropology, sociology, psychology, linguistics, as well as literary and film theory. In the mid to late-20th century it gave way to deconstruction and poststructuralism. Some scholars, such as Roland Barthes, transitioned from a structuralist to a poststructuralist approach over the course of their careers.",
      "image": null,
      "type": "Module",
      "url": null
    },
    "CourseinGeneralLinguistics": {
      "title": "Course in General Linguistics",
      "overview": "",
      "image": "https://images.gr-assets.com/books/1347283800l/287585.jpg",
      "type": "Work",
      "url": null
    },
    "TheGift": {
      "title": "The Gift",
      "overview": "",
      "image": "https://images-na.ssl-images-amazon.com/images/I/51AgYf5d5OL._SX311_BO1,204,203,200_.jpg",
      "type": "Work",
      "url": null
    },
    "TechniquesoftheBody": {
      "title": "Techniques of the Body",
      "overview": "",
      "image": "http://classiques.uqac.ca/classiques/mauss_marcel/socio_et_anthropo/6_Techniques_corps/technique_corps_L.gif",
      "type": "Work",
      "url": null
    },
    "StructuralAnthropology": {
      "title": "Structural Anthropology",
      "overview": "",
      "image": "https://images-na.ssl-images-amazon.com/images/I/51keFLV%2BNsL._SX326_BO1,204,203,200_.jpg",
      "type": "Work",
      "url": null
    },
    "TheSavageMind": {
      "title": "The Savage Mind",
      "overview": "",
      "image": "data:image/jpeg;base64,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",
      "type": "Work",
      "url": null
    },
    "MythologiquesIIV": {
      "title": "Mythologiques I-IV",
      "overview": "",
      "image": "https://kbimages1-a.akamaihd.net/Images/a7f0b499-31cc-42b4-a6df-6e124309a4c5/260/400/85/false/mythologiques-4-l-homme-nu.jpg?method=scale",
      "type": "Work",
      "url": null
    },
    "Mythologies": {
      "title": "Mythologies",
      "overview": "",
      "image": "https://images-na.ssl-images-amazon.com/images/I/51NQ0dp0MgL._SX330_BO1,204,203,200_.jpg",
      "type": "Work",
      "url": null
    },
    "ClaudeLeviStrauss": {
      "title": "Claude Lévi-Strauss",
      "overview": "",
      "image": "https://static01.nyt.com/images/2009/11/03/obituaries/03cnd_strauss/popup.jpg",
      "type": "Author",
      "url": null
    },
    "FerdinanddeSaussure": {
      "title": "Ferdinand de Saussure",
      "overview": "",
      "image": "http://geography.ruhosting.nl/geography/images/a/a5/66558-004-DCD5505D.jpg",
      "type": "Author",
      "url": null
    },
    "MarcelMauss": {
      "title": "Marcel Mauss",
      "overview": "",
      "image": "http://www.tabletmag.com/wp-content/files_mf/1292264773kirsch_121310_380px.jpg",
      "type": "Author",
      "url": null
    },
    "RolandBarthes": {
      "title": "Roland Barthes",
      "overview": "",
      "image": "https://rosswolfe.files.wordpress.com/2015/04/roland-barthes-0001.jpg",
      "type": "Author",
      "url": null
    },
    "RomanJakobson": {
      "title": "Roman Jakobson",
      "overview": "",
      "image": "https://literariness.files.wordpress.com/2016/03/jakobson_roman1.jpg",
      "type": "Author",
      "url": null
    },
    "binaryoppositions": {
      "title": "binary oppositions",
      "overview": "A structuralist device used to map dialectical tensions of a system",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "systemprocess": {
      "title": "system/process",
      "overview": "Structuralism asserts that every process is governed by a system of underlying laws.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "synchronydiachrony": {
      "title": "synchrony/diachrony",
      "overview": "Structuralism distinguishes between the way cultural phenomena can be perceived and analyzed “diachronically” (over time) and “synchronically” (as a single structural unit).",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "techniquesofthebody": {
      "title": "techniques of the body",
      "overview": "In his famous 1934 lecture, Marcel Mauss defined techniques of the body as “the ways in which from society to society men know how to use their bodies” (1973:70). He was referring to the culturally specific, quotidian practices of the body that are at once shaped by and the synthesis of diverse social, biological, and psychological factors.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "functionsoflanguage": {
      "title": "functions of language",
      "overview": "Roman Jakobson distinguished six functions of language: the referential (descriptive statements conveying contextual information); the aesthetic/poetic (focuses on the auto-reflection); emotive (self-expression exemplified by interjections, such as “Wow!”); conative (vocative or imperative addressing of receiver); phatic (language used for the sake of interaction e.g. discussing the weather; checking channel working); metalingual (use of language (code) to discuss itself).",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "bricoleur": {
      "title": "bricoleur",
      "overview": "From the French _bricoler_, this is a term first used by Lévi-Strauss in _The Savage Mind_ (1962) to describe a person adept at many tasks and at putting preexisting things together in new ways. Lévi-Strauss compares the bricoleur, who exemplifies the “savage” or untamed mind, to the engineer, who represents the scientific mind.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "FerdinanddeSaussureBritannica": {
      "title": "Ferdinand de Saussure (Britannica)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "https://www.britannica.com/biography/Ferdinand-de-Saussure"
    },
    "SaussuresThirdCourseofLecturesonGeneralLinguistics": {
      "title": "Saussure's Third Course of Lectures on General Linguistics",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "https://www.marxists.org/reference/subject/philosophy/works/fr/saussure.htm"
    },
    "ClaudeLeviStraussBritannica": {
      "title": "Claude Lévi-Strauss (Britannica)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "https://www.britannica.com/biography/Claude-Levi-Strauss"
    },
    "MarcelMaussBritannica": {
      "title": "Marcel Mauss (Britannica)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "https://www.britannica.com/biography/Marcel-Mauss"
    },
    "RomanJakobsonBritannica": {
      "title": "Roman Jakobson (Britannica)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "https://www.britannica.com/biography/Roman-Jakobson"
    },
    "SemioticsSemiology": {
      "title": "Semiotics/Semiology",
      "overview": "Semiotics is the study of signs and symbols. It investigates how meaning is made and communicated. Semiotics is closely related to the field of linguistics. However, in contradistinction to linguistics, semiotics is also interested in non-linguistic sign systems. The field of semiotics emerged in the late 19th and early 20th century through the independent work of the Swiss linguist Ferdinand de Saussure and the American scientist and philosopher Charles Sanders Peirce. The investigation, within semiotics, of the structure behind the use of particular signs was especially influential on structuralism, which seeks to analyze these relations, and—to a lesser extent—on poststructuralism.",
      "image": null,
      "type": "Module",
      "url": null
    },
    "FoundationsoftheTheoryofSigns": {
      "title": "Foundations of the Theory of Signs",
      "overview": "",
      "image": "https://images-na.ssl-images-amazon.com/images/I/41yYSDKupVL._SY344_BO1,204,203,200_.jpg",
      "type": "Work",
      "url": null
    },
    "ElementsofSemiology": {
      "title": "Elements of Semiology",
      "overview": "",
      "image": "https://images-na.ssl-images-amazon.com/images/I/41Q6YbwXHjL._SX326_BO1,204,203,200_.jpg",
      "type": "Work",
      "url": null
    },
    "ATheoryofSemiotics": {
      "title": "A Theory of Semiotics",
      "overview": "",
      "image": "https://images-na.ssl-images-amazon.com/images/I/41BTsUjo-XL._SY344_BO1,204,203,200_.jpg",
      "type": "Work",
      "url": null
    },
    "TheNameoftheRose": {
      "title": "The Name of the Rose",
      "overview": "",
      "image": "http://images.gr-assets.com/books/1415375471l/119073.jpg",
      "type": "Work",
      "url": null
    },
    "CharlesSandersPeirce": {
      "title": "Charles Sanders Peirce",
      "overview": "",
      "image": "https://media1.britannica.com/eb-media/04/127704-004-3163A0E3.jpg",
      "type": "Author",
      "url": null
    },
    "CharlesWMorris": {
      "title": "Charles W. Morris",
      "overview": "Charles W. Morris (1901-1971) was a semiotician and philosopher. Morris claimed that semiotics was a behavioral science and chose a pragmatic approach to theorize about signs and their relationships. In his book titled _Foundation of the Theory of Signs_ (1938), he presented his understanding of signs as complex vehicles of communication on which humans rely almost exclusively.",
      "image": "https://grd401.files.wordpress.com/2012/06/morris.jpg",
      "type": "Author",
      "url": null
    },
    "UmbertoEco": {
      "title": "Umberto Eco",
      "overview": "",
      "image": "https://s-media-cache-ak0.pinimg.com/originals/44/be/b0/44beb016070daa2d5a93d7599f53c9a5.jpg",
      "type": "Author",
      "url": null
    },
    "sign": {
      "title": "sign",
      "overview": "A basic unit of communication, either linguistic (letter, word) or non-linguistic (image, sound), able to be interpreted by members of a certain group; anything that can be constructed as conveying meaning. Charles S. Peirce defined a sign as “something which stands to somebody for something.” The sign derives its meaning from its relationship to others within the same sign system.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "signifiersignified": {
      "title": "signifier/signified",
      "overview": "According to Ferdinand de Saussure, the sign is made up of two inseparable components: the signifier and the signified. The signifier is the physical form of a sign, such as a sound, written word, or image (as distinct from its meaning). The signified is the concept or idea expressed by a sign. Ferdinand de Saussure claimed that the bond between the signifier and the signified is arbitrary.\n\n![Signifier and Signified](https://markhawa.files.wordpress.com/2014/03/ferdinand-de-saussure-model-signs.jpg)",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "parolelangue": {
      "title": "parole/langue",
      "overview": "Ferdinand de Saussure distinguished between _parole_, or the actual individual utterances, and _langue_, which he defined as the underlying system of conventions that makes individual utterances comprehensible.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "iconindexsymbol": {
      "title": "icon/index/symbol",
      "overview": "Charles S. Peirce categorized signs into three main categories: 1) an icon, which resembles its referent; 2) an index, which is associated with its referent (e.g. smoke is a sign of fire); 3) a symbol, which is related to its referent only by convention (e.g. words or traffic signals).",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "code": {
      "title": "code",
      "overview": "In semiotics, code refers to a set of conventions used to communicate meaning—the most common of which is language.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "semiology": {
      "title": "semiology",
      "overview": "Semiology refers to the study of linguistic signs and symbols. The term _sémiologie_ was first introduced by Ferdinand de Saussure, and is often associated with the Saussurean branch of study.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "CharlesSandersPeirceStanfordEncyclopediaofPhilosophy": {
      "title": "Charles Sanders Peirce (Stanford Encyclopedia of Philosophy)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://plato.stanford.edu/entries/peirce/"
    },
    "CharlesMorrisABriefOutlineofhisPhilosophy": {
      "title": "Charles Morris: A Brief Outline of his Philosophy",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "https://www3.nd.edu/~ehalton/Morrisbio.htm"
    },
    "RolandBarthesBritannica": {
      "title": "Roland Barthes (Britannica)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "https://www.britannica.com/biography/Roland-Gerard-Barthes"
    },
    "UmbertoEcoBritannica": {
      "title": "Umberto Eco (Britannica)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "https://www.britannica.com/biography/Umberto-Eco"
    },
    "ThePeirceGateway": {
      "title": "The Peirce Gateway",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://www.iupui.edu/~arisbe/"
    },
    "DictionaryofPeircesTerms": {
      "title": "Dictionary of Peirce's Terms",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://www.commens.org/dictionary"
    },
    "Postcolonialism": {
      "title": "Postcolonialism",
      "overview": "Postcolonialism, or postcolonial theory, is an intellectual movement that emerged in the mid-20th century. Postcolonial theory undertakes the critical analysis of colonialism and imperialism and examines the cultural, sociopolitical, economic, and psychological effects of colonialism. While postcolonialism is sometimes used to describe the historical period following decolonialization, theorists argue that colonial legacies endure even after independence. As such, postcolonialism can also be seen as a project to reclaim the agency of those subjugated by newer forms of domination—such as global empire.",
      "image": null,
      "type": "Module",
      "url": null
    },
    "BlackSkinWhiteMasks": {
      "title": "Black Skin, White Masks",
      "overview": "",
      "image": "https://images-na.ssl-images-amazon.com/images/I/51UZ437dlvL._SY344_BO1,204,203,200_.jpg",
      "type": "Work",
      "url": null
    },
    "TheWretchedoftheEarth": {
      "title": "The Wretched of the Earth",
      "overview": "",
      "image": "https://images-na.ssl-images-amazon.com/images/I/5195R1wCSLL._SY344_BO1,204,203,200_.jpg",
      "type": "Work",
      "url": null
    },
    "Orientalism": {
      "title": "Orientalism",
      "overview": "",
      "image": "https://upload.wikimedia.org/wikipedia/en/thumb/5/50/Orientalism,_first_edition.jpg/220px-Orientalism,_first_edition.jpg",
      "type": "Work",
      "url": null
    },
    "CultureandImperialism": {
      "title": "Culture and Imperialism",
      "overview": "",
      "image": "https://images-na.ssl-images-amazon.com/images/I/51u0IYeW9DL._SY344_BO1,204,203,200_.jpg",
      "type": "Work",
      "url": null
    },
    "DecolonisingtheMind": {
      "title": "Decolonising the Mind",
      "overview": "",
      "image": "https://upload.wikimedia.org/wikipedia/en/9/9e/Decolonising_the_Mind_cover.jpg",
      "type": "Work",
      "url": null
    },
    "TheLocationofCulture": {
      "title": "The Location of Culture",
      "overview": "",
      "image": "http://images.gr-assets.com/books/1386924491l/187943.jpg",
      "type": "Work",
      "url": null
    },
    "CantheSubalternSpeak": {
      "title": "Can the Subaltern Speak?",
      "overview": "",
      "image": "https://44590e91f93137214d34-d73868e25b2d2bf91c2b7fd7417bb2e3.ssl.cf2.rackcdn.com/columbiauniversitypress_us_frontbookcovers_350W/9780231143844.jpg",
      "type": "Work",
      "url": null
    },
    "CritiqueofPostcolonialReason": {
      "title": "Critique of Postcolonial Reason",
      "overview": "",
      "image": "https://images-na.ssl-images-amazon.com/images/I/51753wBzDnL._SX330_BO1,204,203,200_.jpg",
      "type": "Work",
      "url": null
    },
    "TheatreandPostcolonialDesires": {
      "title": "Theatre and Postcolonial Desires",
      "overview": "",
      "image": "https://images-na.ssl-images-amazon.com/images/I/41CmIsH7GZL._SX314_BO1,204,203,200_.jpg",
      "type": "Work",
      "url": null
    },
    "AwamAmkpa": {
      "title": "Awam Amkpa",
      "overview": "",
      "image": "http://www.blackportraitures.info/wp-content/uploads/2015/03/Awam-Amkpa-crop-262x272.jpg",
      "type": "Author",
      "url": null
    },
    "DipeshChakrabarty": {
      "title": "Dipesh Chakrabarty",
      "overview": "",
      "image": "https://www.uts.edu.au/sites/default/files/chakrabarty_dipesh.jpg",
      "type": "Author",
      "url": null
    },
    "EdwardSaid": {
      "title": "Edward Said",
      "overview": "",
      "image": "http://versobooks-prod.s3.amazonaws.com/images/000003/058/edward-said-portrait-1fe7452f27879d2764f2b74ecd4f45e7.jpg",
      "type": "Author",
      "url": null
    },
    "FrantzFanon": {
      "title": "Frantz Fanon",
      "overview": "",
      "image": "http://www.afrocubaweb.com/images/frantz-fanon.jpg",
      "type": "Author",
      "url": null
    },
    "GayatriChakravortySpivak": {
      "title": "Gayatri Chakravorty Spivak",
      "overview": "",
      "image": "http://blogs.law.columbia.edu/foucault1313/files/2016/04/Gayatri-Chakravorty-Spivak_profile.jpg",
      "type": "Author",
      "url": null
    },
    "HomiBhabha": {
      "title": "Homi Bhabha",
      "overview": "",
      "image": "http://s2.firstpost.in/wp-content/uploads/2016/02/Homi_Wikipedia_380.jpg",
      "type": "Author",
      "url": null
    },
    "NggwaThiongo": {
      "title": "Ngũgĩ wa Thiong’o",
      "overview": "",
      "image": "https://abagond.files.wordpress.com/2012/12/ngugi.jpg",
      "type": "Author",
      "url": null
    },
    "colonialism": {
      "title": "colonialism",
      "overview": "Colonialism is the practice of domination that involves the subjugation of one people by another. The practice usually involves the establishment of a colony in a territory by a political power from another territory.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "imperialism": {
      "title": "imperialism",
      "overview": "An imperial system of government; rule by an emperor or supreme ruler. The exercise of power by one country over another, whether through settlement, sovereignty, or other mechanisms of control.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "hegemony": {
      "title": "hegemony",
      "overview": "[Cultural] hegemony is a concept theorized by Italian Marxist philosopher Antonio Gramsci and refers to the process by which a social class exerts cultural “leadership” or dominance over other classes by maintaining socio-cultural, political, and/or economic power. Whereas imperialism usually refers to direct foreign rule, hegemony implies indirect dominance.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "hybridity": {
      "title": "hybridity",
      "overview": "This term gestures toward the increasing emergence of new cultural forms that result from the encounter of two or more cultures. A notion developed theoretically by Homi K. Bhabha in _Location of Culture_ (1994), hybridity refutes essentialist claims for the inherent authenticity or purity of cultures.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "subaltern": {
      "title": "subaltern",
      "overview": "The term subaltern refers to populations that are socially, politically, economically, and/or geographically outside of the hegemonic power structure. ",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "PostcolonialWeb": {
      "title": "Postcolonial Web",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://postcolonialweb.org"
    },
    "HomiBhabhasFacultyHomepage": {
      "title": "Homi Bhabha’s Faculty Homepage",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://english.fas.harvard.edu/faculty/bhabha/"
    },
    "EdwardSaidBritannica": {
      "title": "Edward Said (Britannica)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "https://www.britannica.com/biography/Edward-Said"
    },
    "GayatriSpivakBritannica": {
      "title": "Gayatri Spivak (Britannica)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "https://www.britannica.com/biography/Gayatri-Spivak"
    },
    "DipeshChakrabartysFacultyHomepage": {
      "title": "Dipesh Chakrabarty’s Faculty Homepage",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "https://history.uchicago.edu/directory/dipesh-chakrabarty"
    },
    "NggwaThiongoBritannica": {
      "title": "Ngũgĩ wa Thiong’o (Britannica)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "https://www.britannica.com/biography/Ngugi-wa-Thiongo"
    },
    "NggwaThiongoshomepage": {
      "title": "Ngũgĩ wa Thiong’o’s homepage",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://www.ngugiwathiongo.com"
    },
    "AwamAmkpaBlackPortraituresConference": {
      "title": "Awam Amkpa | Black Portraitures Conference",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://www.blackportraitures.info/speakers/awam-amkpa/"
    },
    "FrantzFanonInternetEncyclopediaofPhilosophy": {
      "title": "Frantz Fanon (Internet Encyclopedia of Philosophy)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://www.iep.utm.edu/fanon/"
    },
    "Feminisms": {
      "title": "Feminism(s)",
      "overview": "At its core, feminism is the belief in gender equality. The term refers to a broad range of ideologies and movements associated with the advocacy for the establishment of the political, social, and economic rights of women. Feminist theories emerged from women’s political movements, and extended feminist ideologies and practices into philosophy and critical theory.\n\nWhile one can find examples of feminist—or proto-feminist—tendencies as early as antiquity, the issue of women’s rights first became prominent during the French and American revolutions of the late 18th century. Distinct phases of feminist movements are usually referred to as “waves.” First-wave feminism is often traced back to the beginnings of the suffragette movement of the late 19th century, which focused on women’s lack of legal rights. Second-wave feminism emerged in the 1960s, and was primarily concerned with social and economic discrimination against women. Third-wave feminism arose in the 1980s and 1990s largely in response to the lack of racial and economic diversity within second-wave feminism.",
      "image": null,
      "type": "Module",
      "url": null
    },
    "TheSecondSex": {
      "title": "The Second Sex",
      "overview": "",
      "image": "https://images-na.ssl-images-amazon.com/images/I/517cok3plQL._SX303_BO1,204,203,200_.jpg",
      "type": "Work",
      "url": null
    },
    "TheFeminineMystique": {
      "title": "The Feminine Mystique",
      "overview": "",
      "image": "https://upload.wikimedia.org/wikipedia/en/8/8f/The_Feminine_Mystique.jpg",
      "type": "Work",
      "url": null
    },
    "SpeculumoftheOtherWoman": {
      "title": "Speculum of the Other Woman",
      "overview": "",
      "image": "https://images-na.ssl-images-amazon.com/images/I/41rbv%2B1Kb6L._SX331_BO1,204,203,200_.jpg",
      "type": "Work",
      "url": null
    },
    "ThisSexWhichIsNotOne": {
      "title": "This Sex Which Is Not One",
      "overview": "",
      "image": "https://images-na.ssl-images-amazon.com/images/I/413JXP6B88L._AC_UL320_SR210,320_.jpg",
      "type": "Work",
      "url": null
    },
    "VisualPleasureandNarrativeCinema": {
      "title": "Visual Pleasure and Narrative Cinema",
      "overview": "",
      "image": "http://cdn.grin.com/images/cover/brand/e-book/1/65758_big.jpg",
      "type": "Work",
      "url": null
    },
    "BecomingtheThirdWave": {
      "title": "Becoming the Third Wave",
      "overview": "",
      "image": "https://s-media-cache-ak0.pinimg.com/564x/03/25/d1/0325d17a59d16fbdb267eda18eae40fd.jpg",
      "type": "Work",
      "url": null
    },
    "FeminismisforEverybody": {
      "title": "Feminism is for Everybody",
      "overview": "",
      "image": "https://images-na.ssl-images-amazon.com/images/I/5109u%2BGlqZL._SY344_BO1,204,203,200_.jpg",
      "type": "Work",
      "url": null
    },
    "PowersofHorror": {
      "title": "Powers of Horror",
      "overview": "",
      "image": "https://images-na.ssl-images-amazon.com/images/I/41fIWV9M4xL._SY344_BO1,204,203,200_.jpg",
      "type": "Work",
      "url": null
    },
    "AngelaDavis": {
      "title": "Angela Davis",
      "overview": "",
      "image": "https://i.pinimg.com/originals/c3/4f/86/c34f8623f674150ac304912c6f7a651d.jpg",
      "type": "Author",
      "url": null
    },
    "AudreLorde": {
      "title": "Audre Lorde",
      "overview": "",
      "image": "http://www.thefamouspeople.com/profiles/images/audre-lorde-3.jpg",
      "type": "Author",
      "url": null
    },
    "CherrieMoraga": {
      "title": "Cherríe Moraga",
      "overview": "",
      "image": "http://www.txstate.edu/cachea710a905e7d04f83649ef704285ebc29/imagehandler/scaler/gato-docs.its.txstate.edu/jcr:433383e8-e38a-4faf-9b0d-4a899559af4d/cherrie-moraga-2.jpg?mode=fit&width=425",
      "type": "Author",
      "url": null
    },
    "DonnaHaraway": {
      "title": "Donna Haraway",
      "overview": "",
      "image": "https://asunow.asu.edu/sites/default/files/deer_walk_donna_crop_antlers_web.jpg",
      "type": "Author",
      "url": null
    },
    "GloriaSteinem": {
      "title": "Gloria Steinem",
      "overview": "",
      "image": "http://www.harvard.com/images/uploads/events/GLORIA-STEINEM-Annie-Leibovitz.jpg",
      "type": "Author",
      "url": null
    },
    "HeleneCixous": {
      "title": "Hélène Cixous",
      "overview": "",
      "image": "http://quarterlyconversation.com/images/cixous.jpg",
      "type": "Author",
      "url": null
    },
    "JuliaKristeva": {
      "title": "Julia Kristeva",
      "overview": "",
      "image": "https://pbs.twimg.com/profile_images/1799241970/Julia_Kristeva.jpg",
      "type": "Author",
      "url": null
    },
    "LauraMulvey": {
      "title": "Laura Mulvey",
      "overview": "",
      "image": "http://www.underwirefestival.com/wp-content/uploads/2015/05/LM.jpg",
      "type": "Author",
      "url": null
    },
    "LuceIrigaray": {
      "title": "Luce Irigaray",
      "overview": "",
      "image": "https://workingwithluceirigaray.files.wordpress.com/2013/04/irigaray-by-cathy-bernheim.jpg",
      "type": "Author",
      "url": null
    },
    "MaryWollstonecraft": {
      "title": "Mary Wollstonecraft",
      "overview": "",
      "image": "http://www.feministsforlife.org/img/wollstonecraft.jpg",
      "type": "Author",
      "url": null
    },
    "RebeccaWalker": {
      "title": "Rebecca Walker",
      "overview": "",
      "image": "http://www.pariswritersretreat.com/uploads/7/5/3/7/7537574/walker-rebecca-image_orig.jpg",
      "type": "Author",
      "url": null
    },
    "SimonedeBeauvoir": {
      "title": "Simone de Beauvoir",
      "overview": "",
      "image": "data:image/jpeg;base64,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",
      "type": "Author",
      "url": null
    },
    "SojournerTruth": {
      "title": "Sojourner Truth",
      "overview": "",
      "image": "http://cdn.history.com/sites/2/2013/10/sojourner-truth-AB.jpeg",
      "type": "Author",
      "url": null
    },
    "SusanBAnthony": {
      "title": "Susan B. Anthony",
      "overview": "",
      "image": "http://www.gccschool.org/freedom/pics/sba.jpg",
      "type": "Author",
      "url": null
    },
    "bellhooks": {
      "title": "bell hooks",
      "overview": "",
      "image": "http://www.nndb.com/people/593/000115248/bell-hooks.jpg",
      "type": "Author",
      "url": null
    },
    "ecriturefeminine": {
      "title": "écriture féminine",
      "overview": "(lit. feminine writing; women’s writing). First coined by French feminist poet, playwright, and philosopher Hélène Cixous in her seminal 1975 essay “The Laugh of the Medusa,” the term refers to a kind of writing that emblematizes feminine difference and is outside the masculine economy of patriarchal discourse. It expresses what was previously inexpressible; its form emerges out of experimentation and play. Écriture féminine is a fluid, liberatory practice that embraces fragmented, poetic, and performative writing.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "femininemystique": {
      "title": "feminine mystique",
      "overview": "A concept first named and explored by Betty Friedan in her groundbreaking 1963 book of the same title. The feminine mystique is the false notion that a woman’s role in society should be limited to that of a wife, mother, and homemaker. According to Friedan, women are socialized to locate their identity and the meaning of their lives through their husbands and children. This process engenders the loss of a woman’s identity and the displacement of a woman’s desires for the needs of her spouse and family.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "intersectionality": {
      "title": "intersectionality",
      "overview": "The idea of intersectionality was first introduced by Kimberlé Crenshaw in her 1998 discussion of the specific types of discrimination faced by black women. Intersectional theory posits that any one individual belongs to several distinct groups or social categories (e.g. race, class, gender). These interconnected social categorizations create overlapping and interdependent systems of discrimination or disadvantage.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "malegaze": {
      "title": "male gaze",
      "overview": "The male gaze refers to the framing of objects of visual art so that the viewer is situated in the masculine position; objects and phenomena are framed by a male perspective for the viewing pleasure of a heterosexual man. The phrase was coined by Laura Mulvey in her 1975 essay “Visual Pleasure and Narrative Cinema.”",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "masculinist": {
      "title": "masculinist",
      "overview": "Relating to or characteristic of the advocacy of the rights or needs of men and boys; expressing or promoting the opinions or values regarded as typical of men. Some scholars distinguish between “masculism” and “masculinism.” Masculism is associated with the gender egalitarianism of the early men’s movement, while masculinism refers to patriarchal ideologies.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "thepersonalisthepolitical": {
      "title": "the personal is the political",
      "overview": "This phrase became the underlying political contention and rallying slogan of second-wave feminism of the late 1960s. First popularized by Carol Hanisch in her 1969 essay of the same title, the phrase refers to the interrelation between women’s personal experiences and their subordination as women, and further underscores the interconnectedness between personal experience and larger social and political structures and systems.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "phallocentric": {
      "title": "phallocentric",
      "overview": "Centered on the phallus, especially as the symbol of male dominance and authority; man-centered; privileging of the masculine in the construction of meaning.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "womanism": {
      "title": "womanism",
      "overview": "A term proposed by Alice Walker in 1990. An alternative to contemporary feminism, womanism is intended to better address the needs of black women, as well as women of color more broadly.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "SojournerTruthBiographycom": {
      "title": "Sojourner Truth (Biography.com)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://www.biography.com/people/sojourner-truth-9511284"
    },
    "MaryWollstonecraftBiographycom": {
      "title": "Mary Wollstonecraft (Biography.com)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://www.biography.com/people/mary-wollstonecraft-9535967"
    },
    "SusanBAnthonyBiography": {
      "title": "Susan B. Anthony - Biography",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://susanbanthonyhouse.org/her-story/biography.php"
    },
    "SimonedeBeauvoirStanfordEncyclopediaofPhilosophy": {
      "title": "Simone de Beauvoir (Stanford Encyclopedia of Philosophy)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://plato.stanford.edu/entries/beauvoir/"
    },
    "GloriaSteinemsHomepage": {
      "title": "Gloria Steinem's Homepage",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://www.gloriasteinem.com"
    },
    "AngelaDavisFacultyHomepage": {
      "title": "Angela Davis' Faculty Homepage",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://feministstudies.ucsc.edu/faculty/singleton.php?singleton=true&cruz_id=aydavis"
    },
    "DonnaHarawaysFacultyHomepage": {
      "title": "Donna Haraway's Faculty Homepage",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://histcon.ucsc.edu/faculty/singleton.php?&singleton=true&cruz_id=haraway"
    },
    "CherrieMoragasHomepage": {
      "title": "Cherríe Moraga's Homepage",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://www.cherriemoraga.com"
    },
    "RebeccaWalkersHomepage": {
      "title": "Rebecca Walker's Homepage",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://www.rebeccawalker.com"
    },
    "bellhooksInstitute": {
      "title": "bell hooks Institute",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://www.bellhooksinstitute.com"
    },
    "PoemswrittenbyAudreLorde": {
      "title": "Poems written by Audre Lorde",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "https://www.poetryfoundation.org/poems-and-poets/poets/detail/audre-lorde"
    },
    "HeleneCixousBritannica": {
      "title": "Hélène Cixous (Britannica)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "https://www.britannica.com/biography/Helene-Cixous"
    },
    "JuliaKristevasHomepage": {
      "title": "Julia Kristeva's Homepage",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://kristeva.fr"
    },
    "JuliaKristevaBritannica": {
      "title": "Julia Kristeva (Britannica)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "https://www.britannica.com/biography/Julia-Kristeva"
    },
    "SimonedeBeauvoirexplainsWhyImaFeministinaRareTVInterview": {
      "title": "Simone de Beauvoir explains 'Why I'm a Feminist' in a Rare TV Interview",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://www.openculture.com/2013/05/simone_de_beauvoir_explains_why_im_a_feminist_in_a_rare_tv_interview_1975.html"
    },
    "LuceIrigarayBritannica": {
      "title": "Luce Irigaray (Britannica)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "https://www.britannica.com/biography/Luce-Irigaray"
    },
    "Poststructuralism": {
      "title": "Poststructuralism",
      "overview": "Poststructuralism is a movement in literary criticism and philosophy that began in France in the 1960s. It is both an outgrowth and critique of structuralism. Poststructuralists rejected structuralism’s claims to objectivity, comprehensiveness, and universalism. While drawing on the structural linguistics of Ferdinand de Saussure and the anthropological work of Claude Lévi-Strauss, poststructuralists held that language is not a transparent medium that connects one directly to “truth” or “reality.” Instead they emphasized the instability and plurality of meaning.\n\nPoststructuralism and postmodernism are the bases for theories of performativity. To poststructuralists every act, utterance, and idea, is a performative. They regard each phenomenon as part of an endless stream of repetitions with no “first voice” of ultimate authority (Richard Schechner 2002:141-143).",
      "image": null,
      "type": "Module",
      "url": null
    },
    "StructureSignandPlayintheDiscourseoftheHumanSciences": {
      "title": "Structure, Sign, and Play in the Discourse of the Human Sciences",
      "overview": "",
      "image": "https://d2arxad8u2l0g7.cloudfront.net/books/1452772046l/16141232.jpg",
      "type": "Work",
      "url": null
    },
    "OfGrammatology": {
      "title": "Of Grammatology",
      "overview": "",
      "image": "https://d2arxad8u2l0g7.cloudfront.net/books/1348822962l/85326.jpg",
      "type": "Work",
      "url": null
    },
    "WritingandDifference": {
      "title": "Writing and Difference",
      "overview": "",
      "image": "https://d2arxad8u2l0g7.cloudfront.net/books/1347944944l/765346.jpg",
      "type": "Work",
      "url": null
    },
    "LimitedInc": {
      "title": "Limited Inc",
      "overview": "",
      "image": "https://d2arxad8u2l0g7.cloudfront.net/books/1348758688l/175009.jpg",
      "type": "Work",
      "url": null
    },
    "TheArchaeologyofKnowledge": {
      "title": "The Archaeology of Knowledge",
      "overview": "",
      "image": "https://d2arxad8u2l0g7.cloudfront.net/books/1372768188l/232743.jpg",
      "type": "Work",
      "url": null
    },
    "DisciplineandPunish": {
      "title": "Discipline and Punish",
      "overview": "",
      "image": "https://d2arxad8u2l0g7.cloudfront.net/books/1400737037l/80369.jpg",
      "type": "Work",
      "url": null
    },
    "AntiOedipus": {
      "title": "Anti-Oedipus",
      "overview": "",
      "image": "https://d2arxad8u2l0g7.cloudfront.net/books/1347698453l/118317.jpg",
      "type": "Work",
      "url": null
    },
    "AThousandPlateaus": {
      "title": "A Thousand Plateaus",
      "overview": "",
      "image": "https://d2arxad8u2l0g7.cloudfront.net/books/1334679652l/118316.jpg",
      "type": "Work",
      "url": null
    },
    "FelixGuattari": {
      "title": "Félix Guattari",
      "overview": "",
      "image": "http://4.bp.blogspot.com/-8kdJeYGmN0g/Uqvc5Zk8Z1I/AAAAAAAAARg/g8ONm-dNt5M/s640/felix+guattari.jpg",
      "type": "Author",
      "url": null
    },
    "GillesDeleuze": {
      "title": "Gilles Deleuze",
      "overview": "",
      "image": "http://beckybendylegs.com/wp-content/uploads/2015/07/Deleuze.jpg",
      "type": "Author",
      "url": null
    },
    "JacquesDerrida": {
      "title": "Jacques Derrida",
      "overview": "",
      "image": "https://cdn.britannica.com/700x450/95/117695-004-63B45752.jpg",
      "type": "Author",
      "url": null
    },
    "JeanBaudrillard": {
      "title": "Jean Baudrillard",
      "overview": "",
      "image": "http://www.famousphilosophers.org/philosophers/jean-baudrillard.jpg",
      "type": "Author",
      "url": null
    },
    "MichelFoucault": {
      "title": "Michel Foucault",
      "overview": "",
      "image": "http://4.bp.blogspot.com/-xOOIvU1pHho/U9Nt9h4AvkI/AAAAAAAAAKw/p_T8FzKU4Y4/s1600/Screen+Shot+2014-07-26+at+4.58.59+AM.png",
      "type": "Author",
      "url": null
    },
    "deconstruction": {
      "title": "deconstruction",
      "overview": "First introduced by French philosopher Jacques Derrida, deconstruction is a strategy of critical analysis that aims to dismantle binary oppositions, and expose unquestioned assumptions and internal contradictions in philosophical and literary texts.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "deathoftheauthor": {
      "title": "death of the author",
      "overview": "In a 1967 homonymously titled work, Roland Barthes declared “the death of the author” as a single and authentic source of meaning for a given text, arguing instead for the openness of the text and the “birth of the reader” as the source of the multiplicity of meanings of the text.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "differance": {
      "title": "différance",
      "overview": "A noun coined by Jacques Derrida accentuating the double meaning of the French verb _différer_—to “differ” to “deffer.” Différance, or the difference and deferral of meaning, marks the slippage between a work and that to which it refers.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "historicalvsdescriptiveview": {
      "title": "historical vs. descriptive view",
      "overview": "Drawing on Ferdinand de Saussure’s distinction between historical (diachronic) and descriptive (synchronic) theories of language, poststructuralists generally assert that poststructuralism is historical and structuralism is descriptive.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "biopower": {
      "title": "biopower",
      "overview": "A term coined by Michel Foucault denoting the power of a political entity to control and regulate the lives of its populace.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "rhizome": {
      "title": "rhizome",
      "overview": "A philosophical concept proposed by Gilles Deleuze and Félix Guattari. A rhizome is a model and methodology for culture that facilitates multiple, non-hierarchical entry points in a horizontal, de-centered network, which allows immediate connection between any of its points. Rhizomatic mapping resists the organizational structure of the root-tree system, which is hierarchal, ordered, charts causality along chronological lines, and looks for the origin and conclusion of phenomena.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "FelixGuattariBritannica": {
      "title": "Félix Guattari (Britannica)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "https://www.britannica.com/biography/Pierre-Felix-Guattari"
    },
    "GillesDeleuzeBritannica": {
      "title": "Gilles Deleuze (Britannica)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "https://www.britannica.com/biography/Gilles-Deleuze"
    },
    "JacquesDerridaBritannica": {
      "title": "Jacques Derrida (Britannica)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "https://www.britannica.com/biography/Jacques-Derrida"
    },
    "JeanBaudrillardBritannica": {
      "title": "Jean Baudrillard (Britannica)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "https://www.britannica.com/biography/Jean-Baudrillard"
    },
    "MichelFoucaultBritannica": {
      "title": "Michel Foucault (Britannica)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "https://www.britannica.com/biography/Michel-Foucault"
    },
    "Phenomenology": {
      "title": "Phenomenology",
      "overview": "Phenomenology is the study of phenomena. It is a form of inquiry into lived experience that is characterized by an openness to everyday experienced meanings as opposed to theoretical ones. As a philosophical movement it was initiated in the early 20th century by German philosopher Edmund Husserl, who was primarily interested in the systematic study of the structures of consciousness in relation to phenomena. Its methodology involves—to the extent possible—the setting aside of unexamined preconceptions and presuppositions and experiencing objects and phenomena in a way that is direct and unmediated. Phenomenological methodologies have been adopted by many fields that undertake qualitative research, such as anthropology, psychology, and performance—among others. These methods often include the systematic observation and description of pre-theoretical experience.",
      "image": null,
      "type": "Module",
      "url": null
    },
    "IdeasPertainingtoaPurePhenomenologyandtoaPhenomenologicalPhilosophyBooks13": {
      "title": "Ideas Pertaining to a Pure Phenomenology and to a Phenomenological Philosophy, Books 1-3",
      "overview": "",
      "image": "https://images-na.ssl-images-amazon.com/images/I/31vjFUvtRAL._SX332_BO1,204,203,200_.jpg",
      "type": "Work",
      "url": null
    },
    "BeingandTime": {
      "title": "Being and Time",
      "overview": "",
      "image": "https://images-na.ssl-images-amazon.com/images/I/41tHACwkLWL._SX333_BO1,204,203,200_.jpg",
      "type": "Work",
      "url": null
    },
    "PhenomenologyofPerception": {
      "title": "Phenomenology of Perception",
      "overview": "",
      "image": "http://images.gr-assets.com/books/1402711600l/18279.jpg",
      "type": "Work",
      "url": null
    },
    "EdmundHusserl": {
      "title": "Edmund Husserl",
      "overview": "",
      "image": "http://cdn.quotationof.com/images/edmund-husserl-2.jpg",
      "type": "Author",
      "url": null
    },
    "JeanPaulSartre": {
      "title": "Jean-Paul Sartre",
      "overview": "",
      "image": "http://art-sheep.com/wp-content/uploads/2015/07/sartre_22.jpg",
      "type": "Author",
      "url": null
    },
    "MartinHeidegger": {
      "title": "Martin Heidegger",
      "overview": "",
      "image": "http://144ood1pir281165p42ayw0t.wpengine.netdna-cdn.com/heidegger/files/2012/12/Heidegger_1955.jpg",
      "type": "Author",
      "url": null
    },
    "MauriceMerleauPonty": {
      "title": "Maurice Merleau-Ponty",
      "overview": "",
      "image": "https://s-media-cache-ak0.pinimg.com/originals/2c/81/bb/2c81bbaa88b601491a17451502c6d318.jpg",
      "type": "Author",
      "url": null
    },
    "eidos": {
      "title": "eidos",
      "overview": "(From the Greek εἶδος—“species;” that which is seen: form, image, shape) essence; something that is seen or intuited; features of experience that are both necessary and invariant. Philosophers of phenomenology, such as Husserl, propose that the direct and unmediated experience of objects and phenomena allows one to perceive their _eidos_, or essence.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "naturalattitudephenomenologicalattitude": {
      "title": "natural attitude/phenomenological attitude",
      "overview": "In phenomenology, the natural attitude refers to the unexamined, unreflective, and inattentive experience of the world, in which reality is separable from our subjective experience of it. In contrast, the phenomenological attitude indicates a deliberate suspension of judgement, bias, and predisposition toward experience and reality. It is the suspension [or bracketing] of the natural attitude.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "epoche": {
      "title": "epoché",
      "overview": "(From Greek “suspension”) learning to look at things in a way such that we see only what stands before our eyes; only what we can describe and define.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "bracketing": {
      "title": "bracketing",
      "overview": "Suspending or setting aside biases, everyday understandings, theories, beliefs, habitual modes of thought, and judgments—part of the larger process of _epoché_.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "noesisnoema": {
      "title": "noesis/noema",
      "overview": "_Noesis_ is the intentional process of consciousness, while _noema_ is its ideal content.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "ontology": {
      "title": "ontology",
      "overview": "The study of our mode and process of being and existing in the world. A branch of metaphysics concerned with the nature or essence of being or existence.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "EdmundHusserlStanfordEncyclopediaofPhilosophy": {
      "title": "Edmund Husserl (Stanford Encyclopedia of Philosophy)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://plato.stanford.edu/entries/husserl/"
    },
    "Husserlnet": {
      "title": "Husserl.net",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://www.husserl.net/"
    },
    "MartinHeideggerStanfordEncyclopediaofPhilosophy": {
      "title": "Martin Heidegger (Stanford Encyclopedia of Philosophy)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://plato.stanford.edu/entries/heidegger/"
    },
    "JeanPaulSartreStanfordEncyclopediaofPhilosophy": {
      "title": "Jean-Paul Sartre (Stanford Encyclopedia of Philosophy)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://plato.stanford.edu/entries/sartre/"
    },
    "MauriceMerleauPontyPhilpapers": {
      "title": "Maurice Merleau-Ponty (Philpapers)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://philpapers.org/browse/maurice-merleau-ponty"
    },
    "MauriceMerleauPontyStanfordEncyclopediaofPhilosophy": {
      "title": "Maurice Merleau-Ponty (Stanford Encyclopedia of Philosophy)",
      "overview": "",
      "image": null,
      "type": "Link",
      "url": "http://plato.stanford.edu/entries/merleau-ponty/"
    },
    "biopolitics": {
      "title": "biopolitics",
      "overview": "Biopolitics is a concept that theorizes the relationship between bodies and state power. It was developed by the French philosopher Michel Foucault in *The History of Sexuality* Volume I (1976) and in several of his lectures at the Collège de France. Biopolitics describes the way in which modern states maintain their power by regulating the bodies of their subjects. According to Foucault, sovereign rulers used to exercise their power through punishment by death. Around the 17th century, however, rulers began to focus on fostering life. Biopolitics names a mode of political rule that focuses on disciplining the body (through institutions such as the school, police, and military—see also Ideological State Apparatus) and optimizing or regulating the population (through the application of knowledge such as economics, demographics, public health, and housing). It is crucial to the development of capitalism because it produces healthy and productive “docile bodies” for the labor force.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "barelife": {
      "title": "bare life",
      "overview": "Bare life is a concept that theorizes the condition of people who have been stripped of legal and political status and protection. It is best understood in relation to the concept of biopolitics developed by Michel Foucault. Whereas biopolitics explains how a modern state fosters the lives of its citizens, the concept of bare life explains how it treats those it excludes. The term appears in Italian philosopher Giorgio Agamben’s study *Homo Sacer: Sovereign Power and Bare Life* (1995), which takes as its title and point of departure a figure from Roman law (roughly translated as “sacred/accursed man”). The homo sacer was a person who had been banned from society and stripped of his rights, and Agamben reads him as a precursor to the modern-day refugee or internee. For Agamben, the essence of sovereignty lies in the power to distinguish between those who are granted *bios* (the life of the citizen) and those reduced to *zoe* (the state of bare life). We can see this power at work in the Third Reich, whose concentration camps exemplify the production of bare life, which is to say life that does not matter politically. In *Homo Sacer*, Agamben argues that since WWII, the exceptional state of bare life has become the norm since nations no longer value bodies in the way Foucault imagined. While this “state of exception” has generated astonishing violence, it also paradoxically negates sovereign power: if everyone is homo sacer, no one is subject to law and the state has no authority. The upshot of Agamben’s theory is that sovereign power only gains definition through bare life, which defines what it is by identifying what it is not (see also Dialectic).",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "necropolitics": {
      "title": "necropolitics",
      "overview": "Necropolitics is a concept that theorizes the meaning and mechanisms of state violence. It is best understood in relation to the concept of biopolitics developed by Michel Foucault, which describes how a modern state fosters the lives of its citizens. Necropolitics was introduced by Cameroonian theorist Achille Mbembe in his 2003 article “Necropolitics,” and describes the shadowy flip-side of biopolitics. Necropolitics is similar to Giorgio Agamben’s concept of bare life. Both seek to explain the other dimension of sovereignty that Foucault overlooks, its inflicting of death. According to Mbembe, biopolitics only addresses how a sovereign state treats those it has deemed worthy of living. But states also determine who must die, and Mbembe coins the term necropolitics to theorize how this latter group is exposed to the terror of death. He describes the creation of “death-worlds” where entire populations are reduced to the status of “the living dead.” Where Mbembe departs from Agamben is in his specific focus on race and colonization: necropolitics, he insists, always targets racial Others. He goes on to address particular sites of necropolitics (including US slavery, colonial occupation in Africa, Palestine, and apartheid), and one way of understanding his essay is as a postcolonial challenge to the Eurocentrism of Foucault and Agamben.",
      "image": null,
      "type": "Keyword",
      "url": null
    },
    "MediaArchaeology": {
      "title": "Media Archaeology",
      "overview": "Media archaeology is a subfield of media studies that is interested in non-teleological histories of media technologies, scientific devices, and material infrastructures. It sets itself against traditional media histories that trace the origins of particular technologies (books, film, radio, theater, television, and so on) by way of earlier precursor technologies. Instead, media archaeology is most interested in ideas and technologies—like musical automatons, panoramas, the telharmonium, or the hypnobioscope—that otherwise remain ignored or forgotten about by conventional histories. It is fascinated by the supposed “dead ends,” “oddities,” “failed experiments,” and “defunct tributaries” that run alongside other media histories. Major figures include Erkki Huhtamo, Jussi Parikka, Sharron Mattern, and Siegfried Zielinski.",
      "image": null,
      "type": "Module",
      "url": null
    },
    "ActorNetworkTheory": {
      "title": "Actor-Network Theory",
      "overview": "Actor-Network Theory is most strongly associated with the work of French anthropologist and philosopher Bruno Latour, whose iconoclastic work has since the 1980s challenged fundamental assumptions about scholarship, research, and criticism across a wide spectrum of fields in the social sciences and humanities. Actor-Network Theory, or ANT, rethinks the way in which social relationships can be mapped and understood by bringing objects into the realm of the social. This is not merely about highlighting the importance of objects in social life, but rather it is an attempt to put objects on a level playing field with humans in the development of new technologies, ideas, political systems, and so on. Humans and non-humans are equal “actors” in a large social network, each with unique agencies, histories, and power dynamics of their own. The goal in ANT is not to minimize anthropocentrism within social science and humanities fields, but rather to de-center social and humanistic inquiry more generally by understanding power and history to exceed the work of individual human actors. Major figures include Bruno Latour, Michel Callon, John Law, and Annemarie Mol.",
      "image": null,
      "type": "Module",
      "url": null
    },
    "ObjectOrientedOntology": {
      "title": "Object-Oriented Ontology",
      "overview": "Resuscitating the ontological philosophy of Martin Heidegger, a heterogeneous group of philosophers and literary and media scholars began in the late 1990s and early 2000s to coalesce around new philosophies of “thingness” and non-living consciousness. Because this group of scholars is so diverse, the names for their various methods and philosophies vary widely, but all are similarly interested in the volitional and existential quality of the inanimate world. These theories and philosophies approach inanimate objects as conscious entities whose inner lives might be revealed through increased attention, close analysis, and radical sympathy. Ecocritics find these new methods useful as a means for opening new lines of inquiry into human and non-human relationships and as ways of bringing Gaia Theory (understanding the earth as a single, living system) into more mainstream critical usage. Media scholars, on the other hand, find in philosophical projects like Object-Oriented Ontology (OOO) new ways to evaluate how humans and their technologies interact, including in areas of study such as post- and trans-humanism. OOO, whose name is derived from object-oriented programming languages, is especially interested in digital and new media technologies, but extends its theories of artificial intelligence, machine consciousness, and distributive agency to other non-technological objects (rocks and things). Major figures include Bill Brown, Elaine Freedgood, Ian Bogost, Graham Harman, Quintin Meillassoux, Timothy Morton, and Jane Bennett.",
      "image": null,
      "type": "Module",
      "url": null
    }
  },
  "links": [
    [
      "home",
      "QueerTheory"
    ],
    [
      "Disidentifications",
      "QueerTheory"
    ],
    [
      "CruisingUtopia",
      "QueerTheory"
    ],
    [
      "TheTroubleWithNormal",
      "QueerTheory"
    ],
    [
      "NoFuture",
      "QueerTheory"
    ],
    [
      "ThisBridgeCalledMyBack",
      "QueerTheory"
    ],
    [
      "GenderTrouble",
      "QueerTheory"
    ],
    [
      "FearofaQueerPlanetQueerPoliticsandSocialTheory",
      "QueerTheory"
    ],
    [
      "GloriaAnzaldua",
      "QueerTheory"
    ],
    [
      "JoseEstebanMunoz",
      "QueerTheory"
    ],
    [
      "JudithButler",
      "QueerTheory"
    ],
    [
      "LeeEdelman",
      "QueerTheory"
    ],
    [
      "MichaelWarner",
      "QueerTheory"
    ],
    [
      "queer",
      "QueerTheory"
    ],
    [
      "heteronormative",
      "QueerTheory"
    ],
    [
      "antinormative",
      "QueerTheory"
    ],
    [
      "sexuality",
      "QueerTheory"
    ],
    [
      "gender",
      "QueerTheory"
    ],
    [
      "genderidentity",
      "QueerTheory"
    ],
    [
      "disidentification",
      "QueerTheory"
    ],
    [
      "JudithButlerBritannica",
      "QueerTheory"
    ],
    [
      "TheoryorgonButler",
      "QueerTheory"
    ],
    [
      "PoemsbyAnzaldua",
      "QueerTheory"
    ],
    [
      "InterviewwithMunozWhatisPerformanceStudies",
      "QueerTheory"
    ],
    [
      "Disidentifications",
      "JoseEstebanMunoz"
    ],
    [
      "CruisingUtopia",
      "JoseEstebanMunoz"
    ],
    [
      "TheTroubleWithNormal",
      "MichaelWarner"
    ],
    [
      "NoFuture",
      "LeeEdelman"
    ],
    [
      "GenderTrouble",
      "JudithButler"
    ],
    [
      "FearofaQueerPlanetQueerPoliticsandSocialTheory",
      "MichaelWarner"
    ],
    [
      "disidentification",
      "JoseEstebanMunoz"
    ],
    [
      "disidentification",
      "Disidentifications"
    ],
    [
      "JudithButlerBritannica",
      "JudithButler"
    ],
    [
      "TheoryorgonButler",
      "JudithButler"
    ],
    [
      "PoemsbyAnzaldua",
      "GloriaAnzaldua"
    ],
    [
      "InterviewwithMunozWhatisPerformanceStudies",
      "JoseEstebanMunoz"
    ],
    [
      "home",
      "Structuralism"
    ],
    [
      "CourseinGeneralLinguistics",
      "Structuralism"
    ],
    [
      "TheGift",
      "Structuralism"
    ],
    [
      "TechniquesoftheBody",
      "Structuralism"
    ],
    [
      "StructuralAnthropology",
      "Structuralism"
    ],
    [
      "TheSavageMind",
      "Structuralism"
    ],
    [
      "MythologiquesIIV",
      "Structuralism"
    ],
    [
      "Mythologies",
      "Structuralism"
    ],
    [
      "ClaudeLeviStrauss",
      "Structuralism"
    ],
    [
      "FerdinanddeSaussure",
      "Structuralism"
    ],
    [
      "MarcelMauss",
      "Structuralism"
    ],
    [
      "RolandBarthes",
      "Structuralism"
    ],
    [
      "RomanJakobson",
      "Structuralism"
    ],
    [
      "binaryoppositions",
      "Structuralism"
    ],
    [
      "systemprocess",
      "Structuralism"
    ],
    [
      "synchronydiachrony",
      "Structuralism"
    ],
    [
      "techniquesofthebody",
      "Structuralism"
    ],
    [
      "functionsoflanguage",
      "Structuralism"
    ],
    [
      "bricoleur",
      "Structuralism"
    ],
    [
      "FerdinanddeSaussureBritannica",
      "Structuralism"
    ],
    [
      "SaussuresThirdCourseofLecturesonGeneralLinguistics",
      "Structuralism"
    ],
    [
      "ClaudeLeviStraussBritannica",
      "Structuralism"
    ],
    [
      "MarcelMaussBritannica",
      "Structuralism"
    ],
    [
      "RomanJakobsonBritannica",
      "Structuralism"
    ],
    [
      "CourseinGeneralLinguistics",
      "FerdinanddeSaussure"
    ],
    [
      "TheGift",
      "MarcelMauss"
    ],
    [
      "TechniquesoftheBody",
      "MarcelMauss"
    ],
    [
      "StructuralAnthropology",
      "ClaudeLeviStrauss"
    ],
    [
      "TheSavageMind",
      "ClaudeLeviStrauss"
    ],
    [
      "MythologiquesIIV",
      "ClaudeLeviStrauss"
    ],
    [
      "Mythologies",
      "RolandBarthes"
    ],
    [
      "techniquesofthebody",
      "MarcelMauss"
    ],
    [
      "techniquesofthebody",
      "TechniquesoftheBody"
    ],
    [
      "functionsoflanguage",
      "RomanJakobson"
    ],
    [
      "bricoleur",
      "ClaudeLeviStrauss"
    ],
    [
      "FerdinanddeSaussureBritannica",
      "FerdinanddeSaussure"
    ],
    [
      "SaussuresThirdCourseofLecturesonGeneralLinguistics",
      "FerdinanddeSaussure"
    ],
    [
      "ClaudeLeviStraussBritannica",
      "ClaudeLeviStrauss"
    ],
    [
      "MarcelMaussBritannica",
      "MarcelMauss"
    ],
    [
      "RonaldBarthesBritannica",
      "RolandBarthes"
    ],
    [
      "RomanJakobsonBritannica",
      "RomanJakobson"
    ],
    [
      "home",
      "SemioticsSemiology"
    ],
    [
      "CourseinGeneralLinguistics",
      "SemioticsSemiology"
    ],
    [
      "FoundationsoftheTheoryofSigns",
      "SemioticsSemiology"
    ],
    [
      "ElementsofSemiology",
      "SemioticsSemiology"
    ],
    [
      "ATheoryofSemiotics",
      "SemioticsSemiology"
    ],
    [
      "TheNameoftheRose",
      "SemioticsSemiology"
    ],
    [
      "CharlesSandersPeirce",
      "SemioticsSemiology"
    ],
    [
      "CharlesWMorris",
      "SemioticsSemiology"
    ],
    [
      "FerdinanddeSaussure",
      "SemioticsSemiology"
    ],
    [
      "RolandBarthes",
      "SemioticsSemiology"
    ],
    [
      "UmbertoEco",
      "SemioticsSemiology"
    ],
    [
      "sign",
      "SemioticsSemiology"
    ],
    [
      "signifiersignified",
      "SemioticsSemiology"
    ],
    [
      "parolelangue",
      "SemioticsSemiology"
    ],
    [
      "iconindexsymbol",
      "SemioticsSemiology"
    ],
    [
      "code",
      "SemioticsSemiology"
    ],
    [
      "semiology",
      "SemioticsSemiology"
    ],
    [
      "FerdinanddeSaussureBritannica",
      "SemioticsSemiology"
    ],
    [
      "CharlesSandersPeirceStanfordEncyclopediaofPhilosophy",
      "SemioticsSemiology"
    ],
    [
      "CharlesMorrisABriefOutlineofhisPhilosophy",
      "SemioticsSemiology"
    ],
    [
      "RolandBarthesBritannica",
      "SemioticsSemiology"
    ],
    [
      "UmbertoEcoBritannica",
      "SemioticsSemiology"
    ],
    [
      "ThePeirceGateway",
      "SemioticsSemiology"
    ],
    [
      "DictionaryofPeircesTerms",
      "SemioticsSemiology"
    ],
    [
      "FoundationsoftheTheoryofSigns",
      "CharlesWMorris"
    ],
    [
      "ElementsofSemiology",
      "RolandBarthes"
    ],
    [
      "ATheoryofSemiotics",
      "UmbertoEco"
    ],
    [
      "TheNameoftheRose",
      "UmbertoEco"
    ],
    [
      "sign",
      "CharlesSandersPeirce"
    ],
    [
      "signifiersignified",
      "FerdinanddeSaussure"
    ],
    [
      "parolelangue",
      "FerdinanddeSaussure"
    ],
    [
      "iconindexsymbol",
      "CharlesSandersPeirce"
    ],
    [
      "semiology",
      "FerdinanddeSaussure"
    ],
    [
      "CharlesSandersPeirceStanfordEncyclopediaofPhilosophy",
      "CharlesSandersPeirce"
    ],
    [
      "CharlesMorrisABriefOutlineofhisPhilosophy",
      "CharlesWMorris"
    ],
    [
      "RolandBarthesBritannica",
      "RolandBarthes"
    ],
    [
      "UmbertoEcoBritannica",
      "UmbertoEco"
    ],
    [
      "ThePeirceGateway",
      "CharlesSandersPeirce"
    ],
    [
      "DictionaryofPeircesTerms",
      "CharlesSandersPeirce"
    ],
    [
      "home",
      "Postcolonialism"
    ],
    [
      "BlackSkinWhiteMasks",
      "Postcolonialism"
    ],
    [
      "TheWretchedoftheEarth",
      "Postcolonialism"
    ],
    [
      "Orientalism",
      "Postcolonialism"
    ],
    [
      "CultureandImperialism",
      "Postcolonialism"
    ],
    [
      "DecolonisingtheMind",
      "Postcolonialism"
    ],
    [
      "TheLocationofCulture",
      "Postcolonialism"
    ],
    [
      "CantheSubalternSpeak",
      "Postcolonialism"
    ],
    [
      "CritiqueofPostcolonialReason",
      "Postcolonialism"
    ],
    [
      "TheatreandPostcolonialDesires",
      "Postcolonialism"
    ],
    [
      "AwamAmkpa",
      "Postcolonialism"
    ],
    [
      "DipeshChakrabarty",
      "Postcolonialism"
    ],
    [
      "EdwardSaid",
      "Postcolonialism"
    ],
    [
      "FrantzFanon",
      "Postcolonialism"
    ],
    [
      "GayatriChakravortySpivak",
      "Postcolonialism"
    ],
    [
      "HomiBhabha",
      "Postcolonialism"
    ],
    [
      "NggwaThiongo",
      "Postcolonialism"
    ],
    [
      "colonialism",
      "Postcolonialism"
    ],
    [
      "imperialism",
      "Postcolonialism"
    ],
    [
      "hegemony",
      "Postcolonialism"
    ],
    [
      "hybridity",
      "Postcolonialism"
    ],
    [
      "subaltern",
      "Postcolonialism"
    ],
    [
      "PostcolonialWeb",
      "Postcolonialism"
    ],
    [
      "HomiBhabhasFacultyHomepage",
      "Postcolonialism"
    ],
    [
      "EdwardSaidBritannica",
      "Postcolonialism"
    ],
    [
      "GayatriSpivakBritannica",
      "Postcolonialism"
    ],
    [
      "DipeshChakrabartysFacultyHomepage",
      "Postcolonialism"
    ],
    [
      "NggwaThiongoBritannica",
      "Postcolonialism"
    ],
    [
      "NggwaThiongoshomepage",
      "Postcolonialism"
    ],
    [
      "AwamAmkpaBlackPortraituresConference",
      "Postcolonialism"
    ],
    [
      "FrantzFanonInternetEncyclopediaofPhilosophy",
      "Postcolonialism"
    ],
    [
      "BlackSkinWhiteMasks",
      "FrantzFanon"
    ],
    [
      "TheWretchedoftheEarth",
      "FrantzFanon"
    ],
    [
      "Orientalism",
      "EdwardSaid"
    ],
    [
      "CultureandImperialism",
      "EdwardSaid"
    ],
    [
      "DecolonisingtheMind",
      "NggwaThiongo"
    ],
    [
      "TheLocationofCulture",
      "HomiBhabha"
    ],
    [
      "CantheSubalternSpeak",
      "GayatriChakravortySpivak"
    ],
    [
      "CritiqueofPostcolonialReason",
      "GayatriChakravortySpivak"
    ],
    [
      "TheatreandPostcolonialDesires",
      "AwamAmkpa"
    ],
    [
      "Orientalism",
      "Orientalism"
    ],
    [
      "hybridity",
      "HomiBhabha"
    ],
    [
      "hybridity",
      "TheLocationofCulture"
    ],
    [
      "subaltern",
      "GayatriChakravortySpivak"
    ],
    [
      "subaltern",
      "CantheSubalternSpeak"
    ],
    [
      "PostcolonialWeb",
      "postcolonial"
    ],
    [
      "HomiBhabhasFacultyHomepage",
      "HomiBhabha"
    ],
    [
      "EdwardSaidBritannica",
      "EdwardSaid"
    ],
    [
      "GayatriSpivakBritannica",
      "GayatriChakravortySpivak"
    ],
    [
      "DipeshChakrabartysFacultyHomepage",
      "DipeshChakrabarty"
    ],
    [
      "NggwaThiongoBritannica",
      "NggwaThiongo"
    ],
    [
      "NggwaThiongoshomepage",
      "NggwaThiongo"
    ],
    [
      "AwamAmkpaBlackPortraituresConference",
      "AwamAmkpa"
    ],
    [
      "FrantzFanonInternetEncyclopediaofPhilosophy",
      "FrantzFanon"
    ],
    [
      "home",
      "Feminisms"
    ],
    [
      "TheSecondSex",
      "Feminisms"
    ],
    [
      "TheFeminineMystique",
      "Feminisms"
    ],
    [
      "SpeculumoftheOtherWoman",
      "Feminisms"
    ],
    [
      "ThisSexWhichIsNotOne",
      "Feminisms"
    ],
    [
      "VisualPleasureandNarrativeCinema",
      "Feminisms"
    ],
    [
      "ThisBridgeCalledMyBack",
      "Feminisms"
    ],
    [
      "GenderTrouble",
      "Feminisms"
    ],
    [
      "BecomingtheThirdWave",
      "Feminisms"
    ],
    [
      "FeminismisforEverybody",
      "Feminisms"
    ],
    [
      "PowersofHorror",
      "Feminisms"
    ],
    [
      "AngelaDavis",
      "Feminisms"
    ],
    [
      "AudreLorde",
      "Feminisms"
    ],
    [
      "CherrieMoraga",
      "Feminisms"
    ],
    [
      "DonnaHaraway",
      "Feminisms"
    ],
    [
      "GloriaAnzaldua",
      "Feminisms"
    ],
    [
      "GloriaSteinem",
      "Feminisms"
    ],
    [
      "HeleneCixous",
      "Feminisms"
    ],
    [
      "JudithButler",
      "Feminisms"
    ],
    [
      "JuliaKristeva",
      "Feminisms"
    ],
    [
      "LauraMulvey",
      "Feminisms"
    ],
    [
      "LuceIrigaray",
      "Feminisms"
    ],
    [
      "MaryWollstonecraft",
      "Feminisms"
    ],
    [
      "RebeccaWalker",
      "Feminisms"
    ],
    [
      "SimonedeBeauvoir",
      "Feminisms"
    ],
    [
      "SojournerTruth",
      "Feminisms"
    ],
    [
      "SusanBAnthony",
      "Feminisms"
    ],
    [
      "bellhooks",
      "Feminisms"
    ],
    [
      "ecriturefeminine",
      "Feminisms"
    ],
    [
      "femininemystique",
      "Feminisms"
    ],
    [
      "intersectionality",
      "Feminisms"
    ],
    [
      "malegaze",
      "Feminisms"
    ],
    [
      "masculinist",
      "Feminisms"
    ],
    [
      "thepersonalisthepolitical",
      "Feminisms"
    ],
    [
      "phallocentric",
      "Feminisms"
    ],
    [
      "womanism",
      "Feminisms"
    ],
    [
      "SojournerTruthBiographycom",
      "Feminisms"
    ],
    [
      "MaryWollstonecraftBiographycom",
      "Feminisms"
    ],
    [
      "SusanBAnthonyBiography",
      "Feminisms"
    ],
    [
      "SimonedeBeauvoirStanfordEncyclopediaofPhilosophy",
      "Feminisms"
    ],
    [
      "GloriaSteinemsHomepage",
      "Feminisms"
    ],
    [
      "AngelaDavisFacultyHomepage",
      "Feminisms"
    ],
    [
      "DonnaHarawaysFacultyHomepage",
      "Feminisms"
    ],
    [
      "CherrieMoragasHomepage",
      "Feminisms"
    ],
    [
      "PoemsbyAnzaldua",
      "Feminisms"
    ],
    [
      "RebeccaWalkersHomepage",
      "Feminisms"
    ],
    [
      "bellhooksInstitute",
      "Feminisms"
    ],
    [
      "PoemswrittenbyAudreLorde",
      "Feminisms"
    ],
    [
      "TheoryorgonButler",
      "Feminisms"
    ],
    [
      "HeleneCixousBritannica",
      "Feminisms"
    ],
    [
      "JuliaKristevasHomepage",
      "Feminisms"
    ],
    [
      "JuliaKristevaBritannica",
      "Feminisms"
    ],
    [
      "SimonedeBeauvoirexplainsWhyImaFeministinaRareTVInterview",
      "Feminisms"
    ],
    [
      "JudithButlerBritannica",
      "Feminisms"
    ],
    [
      "LuceIrigarayBritannica",
      "Feminisms"
    ],
    [
      "TheSecondSex",
      "SimonedeBeauvoir"
    ],
    [
      "SpeculumoftheOtherWoman",
      "LuceIrigaray"
    ],
    [
      "ThisSexWhichIsNotOne",
      "LuceIrigaray"
    ],
    [
      "VisualPleasureandNarrativeCinema",
      "LauraMulvey"
    ],
    [
      "ThisBridgeCalledMyBack",
      "CherrieMoraga"
    ],
    [
      "ThisBridgeCalledMyBack",
      "GloriaAnzaldua"
    ],
    [
      "BecomingtheThirdWave",
      "RebeccaWalker"
    ],
    [
      "FeminismisforEverybody",
      "bellhooks"
    ],
    [
      "PowersofHorror",
      "JuliaKristeva"
    ],
    [
      "ecriturefeminine",
      "HeleneCixous"
    ],
    [
      "femininemystique",
      "TheFeminineMystique"
    ],
    [
      "malegaze",
      "LauraMulvey"
    ],
    [
      "malegaze",
      "VisualPleasureandNarrativeCinema"
    ],
    [
      "SojournerTruthBiographycom",
      "SojournerTruth"
    ],
    [
      "MaryWollstonecraftBiographycom",
      "MaryWollstonecraft"
    ],
    [
      "SusanBAnthonyBiography",
      "SusanBAnthony"
    ],
    [
      "SimonedeBeauvoirStanfordEncyclopediaofPhilosophy",
      "SimonedeBeauvoir"
    ],
    [
      "GloriaSteinemsHomepage",
      "GloriaSteinem"
    ],
    [
      "AngelaDavisFacultyHomepage",
      "AngelaDavis"
    ],
    [
      "DonnaHarawaysFacultyHomepage",
      "DonnaHaraway"
    ],
    [
      "CherrieMoragasHomepage",
      "CherrieMoraga"
    ],
    [
      "RebeccaWalkersHomepage",
      "RebeccaWalker"
    ],
    [
      "bellhooksInstitute",
      "bellhooks"
    ],
    [
      "PoemswrittenbyAudreLorde",
      "AudreLorde"
    ],
    [
      "HeleneCixousBritannica",
      "HeleneCixous"
    ],
    [
      "LuceIrigaray",
      "httpwwwieputmeduirigaray"
    ],
    [
      "JuliaKristevasHomepage",
      "JuliaKristeva"
    ],
    [
      "JuliaKristevaBritannica",
      "JuliaKristeva"
    ],
    [
      "SimonedeBeauvoirexplainsWhyImaFeministinaRareTVInterview",
      "SimonedeBeauvoir"
    ],
    [
      "LuceIrigarayBritannica",
      "LuceIrigaray"
    ],
    [
      "home",
      "Poststructuralism"
    ],
    [
      "StructureSignandPlayintheDiscourseoftheHumanSciences",
      "Poststructuralism"
    ],
    [
      "OfGrammatology",
      "Poststructuralism"
    ],
    [
      "WritingandDifference",
      "Poststructuralism"
    ],
    [
      "LimitedInc",
      "Poststructuralism"
    ],
    [
      "TheArchaeologyofKnowledge",
      "Poststructuralism"
    ],
    [
      "DisciplineandPunish",
      "Poststructuralism"
    ],
    [
      "ElementsofSemiology",
      "Poststructuralism"
    ],
    [
      "AntiOedipus",
      "Poststructuralism"
    ],
    [
      "AThousandPlateaus",
      "Poststructuralism"
    ],
    [
      "PowersofHorror",
      "Poststructuralism"
    ],
    [
      "GenderTrouble",
      "Poststructuralism"
    ],
    [
      "FelixGuattari",
      "Poststructuralism"
    ],
    [
      "GillesDeleuze",
      "Poststructuralism"
    ],
    [
      "JacquesDerrida",
      "Poststructuralism"
    ],
    [
      "JeanBaudrillard",
      "Poststructuralism"
    ],
    [
      "JudithButler",
      "Poststructuralism"
    ],
    [
      "JuliaKristeva",
      "Poststructuralism"
    ],
    [
      "MichelFoucault",
      "Poststructuralism"
    ],
    [
      "RolandBarthes",
      "Poststructuralism"
    ],
    [
      "deconstruction",
      "Poststructuralism"
    ],
    [
      "deathoftheauthor",
      "Poststructuralism"
    ],
    [
      "differance",
      "Poststructuralism"
    ],
    [
      "historicalvsdescriptiveview",
      "Poststructuralism"
    ],
    [
      "biopower",
      "Poststructuralism"
    ],
    [
      "rhizome",
      "Poststructuralism"
    ],
    [
      "FelixGuattariBritannica",
      "Poststructuralism"
    ],
    [
      "GillesDeleuzeBritannica",
      "Poststructuralism"
    ],
    [
      "JacquesDerridaBritannica",
      "Poststructuralism"
    ],
    [
      "JeanBaudrillardBritannica",
      "Poststructuralism"
    ],
    [
      "MichelFoucaultBritannica",
      "Poststructuralism"
    ],
    [
      "JudithButlerBritannica",
      "Poststructuralism"
    ],
    [
      "TheoryorgonButler",
      "Poststructuralism"
    ],
    [
      "JuliaKristevaBritannica",
      "Poststructuralism"
    ],
    [
      "JuliaKristevasHomepage",
      "Poststructuralism"
    ],
    [
      "StructureSignandPlayintheDiscourseoftheHumanSciences",
      "JacquesDerrida"
    ],
    [
      "OfGrammatology",
      "JacquesDerrida"
    ],
    [
      "WritingandDifference",
      "JacquesDerrida"
    ],
    [
      "LimitedInc",
      "JacquesDerrida"
    ],
    [
      "TheArchaeologyofKnowledge",
      "MichelFoucault"
    ],
    [
      "DisciplineandPunish",
      "MichelFoucault"
    ],
    [
      "AntiOedipus",
      "GillesDeleuze"
    ],
    [
      "AntiOedipus",
      "FelixGuattari"
    ],
    [
      "AThousandPlateaus",
      "GillesDeleuze"
    ],
    [
      "AThousandPlateaus",
      "FelixGuattari"
    ],
    [
      "deconstruction",
      "JacquesDerrida"
    ],
    [
      "deathoftheauthor",
      "RolandBarthes"
    ],
    [
      "differance",
      "JacquesDerrida"
    ],
    [
      "biopower",
      "MichelFoucault"
    ],
    [
      "rhizome",
      "GillesDeleuze"
    ],
    [
      "rhizome",
      "FelixGuattari"
    ],
    [
      "FelixGuattariBritannica",
      "FelixGuattari"
    ],
    [
      "GillesDeleuzeBritannica",
      "GillesDeleuze"
    ],
    [
      "JacquesDerridaBritannica",
      "JacquesDerrida"
    ],
    [
      "JeanBaudrillardBritannica",
      "JeanBaudrillard"
    ],
    [
      "MichelFoucaultBritannica",
      "MichelFoucault"
    ],
    [
      "home",
      "Phenomenology"
    ],
    [
      "IdeasPertainingtoaPurePhenomenologyandtoaPhenomenologicalPhilosophyBooks13",
      "Phenomenology"
    ],
    [
      "BeingandTime",
      "Phenomenology"
    ],
    [
      "PhenomenologyofPerception",
      "Phenomenology"
    ],
    [
      "EdmundHusserl",
      "Phenomenology"
    ],
    [
      "JeanPaulSartre",
      "Phenomenology"
    ],
    [
      "MartinHeidegger",
      "Phenomenology"
    ],
    [
      "MauriceMerleauPonty",
      "Phenomenology"
    ],
    [
      "eidos",
      "Phenomenology"
    ],
    [
      "naturalattitudephenomenologicalattitude",
      "Phenomenology"
    ],
    [
      "epoche",
      "Phenomenology"
    ],
    [
      "bracketing",
      "Phenomenology"
    ],
    [
      "noesisnoema",
      "Phenomenology"
    ],
    [
      "ontology",
      "Phenomenology"
    ],
    [
      "EdmundHusserlStanfordEncyclopediaofPhilosophy",
      "Phenomenology"
    ],
    [
      "Husserlnet",
      "Phenomenology"
    ],
    [
      "MartinHeideggerStanfordEncyclopediaofPhilosophy",
      "Phenomenology"
    ],
    [
      "JeanPaulSartreStanfordEncyclopediaofPhilosophy",
      "Phenomenology"
    ],
    [
      "MauriceMerleauPontyPhilpapers",
      "Phenomenology"
    ],
    [
      "MauriceMerleauPontyStanfordEncyclopediaofPhilosophy",
      "Phenomenology"
    ],
    [
      "IdeasPertainingtoaPurePhenomenologyandtoaPhenomenologicalPhilosophyBooks13",
      "EdmundHusserl"
    ],
    [
      "BeingandTime",
      "MartinHeidegger"
    ],
    [
      "PhenomenologyofPerception",
      "MauriceMerleauPonty"
    ],
    [
      "bracketing",
      "epoche"
    ],
    [
      "EdmundHusserlStanfordEncyclopediaofPhilosophy",
      "EdmundHusserl"
    ],
    [
      "Husserlnet",
      "EdmundHusserl"
    ],
    [
      "MartinHeideggerStanfordEncyclopediaofPhilosophy",
      "MartinHeidegger"
    ],
    [
      "JeanPaulSartreStanfordEncyclopediaofPhilosophy",
      "JeanPaulSartre"
    ],
    [
      "MauriceMerleauPontyPhilpapers",
      "MauriceMerleauPonty"
    ],
    [
      "MauriceMerleauPontyStanfordEncyclopediaofPhilosophy",
      "MauriceMerleauPonty"
    ],
    [
      "necropolitics",
      "barelife"
    ],
    [
      "biopolitics",
      "necropolitics"
    ],
    [
      "biopolitics",
      "barelife"
    ],
    [
      "necropolitics",
      "MichelFoucault"
    ],
    [
      "biopolitics",
      "MichelFoucault"
    ],
    [
      "MichelFoucault",
      "barelife"
    ],
    // [
    //   "ActorNetworkTheory",
    //   "home"
    // ],
    // [
    //   "ObjectOrientedOntology",
    //   "home"
    // ],
    // [
    //   "MediaArchaeology",
    //   "home"
    // ]
  ]
}

export default thing
// exports = {thing}
// export default {
//   entities: {
//     'home': {
//       title: 'Performance | Theory',
//       overview: 'Welcome to the companion site for Professor Dominika Laster’s Theories of Theatre and Performance Theory seminars, which serve as an introduction to the theories undergirding the dynamic fields of theatre and performance studies—its methodologies, genealogies, and current trends. This course website features short introductory modules on select theories, movements, relevant figures, and definitions of key terms. This evolving platform is intended as a point of departure for research, and is by no means exhaustive.'
//     },
//     'queertheory': {
//       title: 'Queer Theory',
//       type: 'Module',
//       overview: 'Queer theory is a field of critical discourse that critiques those cultural institutions and practices which enforce normative ways of being, doing, and knowing. It builds upon feminist re-conceptualizations of gender and sexuality by adding the perspective of thinkers who challenge the very viability of, for example, gender identification or sexual orientation. Aligned with the poststructuralist critique of the humanist model of the subject, queer theory offers various understandings of human identity as created performatively, constructed discursively, or else always culturally and historically specific—i.e., never age-old, intrinsic, or by nature.\n\nWhile often associated with the LGBT community, queer theory asks questions beyond any one cultural group, and does not limit itself to conversations regarding sexuality and gender. In fact, queer theory joins other theoretical projects in understanding that racial, sexual, national, class, and gender identities all exist at a complex intersection with one another in any given person or culture. As such, queer theory is as much a mode of inquiry and analysis as it is a study of people who call themselves “queer.” In general, queer theory itself queers—in an intellectual and theory sense—by taking up various projects of de-legitimizing, troubling, challenging, camping up, or de-familiarizing. It finds objects of analysis across history, but most always seeks to de-stabilize the patriarchal, heteronormative, and racist underpinnings of our society.'
//     },
//     'ganzaldua': {
//       title: 'Gloria Anzaldúa',
//       type: 'Author',
//       image: 'https://static.wixstatic.com/media/1effaa_158bb9db61dc45dd9d882883c740e3f1.jpg/v1/fill/w_420,h_420,al_c,lg_1,q_80/1effaa_158bb9db61dc45dd9d882883c740e3f1.jpg',
//       overview: 'Gloria Anzaldúa was born in 1942 and died in 2004. She was a scholar of Chicana cultural theory, feminism, and queer theory. She is well known for editing *This Bridge Called My Back: Writings by Radical Women of Color* with Cherríe Moraga and for writing the highly influential *Borderlands/La Frontera: The New Mestiza*. She often wrote many of her texts in “Spanglish.” In her essay “La Prieta,” collected in *This Bridge Called My Back*, she argues that the queer can also be considered in terms of race, giving a personal account of the ways in which her skin color affected her life as a queer woman. Anzaldúa writes, “in [my mother’s] eyes and in the eyes of others I saw myself reflected as ‘Strange’, ‘abnormal’, ‘QUEER.’ I saw no other reflection.” In her writing, she also argues that even within the groups with which one self-identifies, one can feel isolated, due to other differences. On this topic, Anzaldúa says “we are the queer groups, the people that don’t belong anywhere, not in the dominant world nor completely within our own respective cultures.”'
//     }
//   },
//   links: [
//     ['home', 'queertheory'],
//     ['queertheory', 'ganzaldua']
//   ]
// }



// WEBPACK FOOTER //
// ./src/content/index.js